<script>
const loginEffectiveTime = 480; // 以分钟计算
const faceUrl = "https://mkoa.kingsoft.com/oa/kingsoft_photo/"; // 头像地址
const clientHeight = document.documentElement.clientHeight; //获取浏览器窗口的可视区域的高度

function getRatio(StandNum, Total, num) {
  if (typeof StandNum !== "number") {
    StandNum = 0;
  }
  if (typeof Total !== "number") {
    Total = 0;
  }
  if (typeof num !== "number") {
    num = 1;
  }
  let ratio = "0%";
  if (!isNaN((StandNum / Total) * 100)) {
    ratio = ((StandNum / Total) * 100).toFixed(num) + "%";
  }
  return ratio;
}
function getRatioFalse(StandNum, Total, num) {
  if (typeof StandNum !== "number") {
    StandNum = 0;
  }
  if (typeof Total !== "number") {
    Total = 0;
  }
  if (typeof num !== "number") {
    num = 1;
  }
  let ratio = "0";
  if (!isNaN((StandNum / Total) * 100)) {
    ratio = ((StandNum / Total) * 100).toFixed(num);
  }
  return ratio;
}

function getMenuUrl() {
  //获取正式或者测试环境的域名
  let propurls;
  if (process.env.NODE_ENV === "development") {
    propurls = "http://test-yunpai.yuntiankuajing.com/yunpai_api/";
  } else {
    if (process.env.NODE_ENV === "test") {
      propurls = "http://test-yunpai.yuntiankuajing.com/yunpai_api/";
    } else {
      propurls = "https://yunpai.yuntiankuajing.com/yunpai_api/";
    }
  }
  return propurls;
}


const pageArr = [5, 10, 20, 50, 100];
const pageSize = 20;
const pageSizeDp = 100
//账号状态
const accountStatus = [
  {
    value: "1",
    label: "正常",
    enName:'normal'
  },
  {
    value: "0",
    label: "禁用",
    enName:'dissbled'
  },
]

// 账号状态转文字
function getaccountStatusList(val,locale) {
  const item = this.accountStatus.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.label : "";
}

// 商家认证审核状态
const attestationStatus = [
  {
    value: "0",
    label: "待审核",
  },
  {
    value: "1",
    label: "审核通过",
  },
  {
    value: "-1",
    label: "审核不通过",
  },
]
// 商家认证审核状态转文字
function getAttestationStateList(val) {
  const item = this.attestationStatus.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? item.label : "";
}

// 所属平台
const allPlatform = [
  { value: 1, label: 'lazada' },
  { value: 2, label: 'Shopee' },
  { value: 3, label: 'TikTok' },
];
// 所属平台转文字
function getallPlatformList(val) {
  const item = this.allPlatform.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? item.label : "";
}


// 是否包邮
const allIsPost = [
  { value: 0, label: '不包邮' },
  { value: 1, label: '包邮' },
];

// 每单品类
const allReplyItems = [
  { value: 1, label: '一单一SKU' },
  { value: 2, label: '一单两SKU' },
  { value: 3, label: '一单三SKU' },
];

// 所属平台状态转文字
function getAllPlatformList(val) {
  const item = this.allPlatform.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? item.label : "";
}

/** 每单品类 */
export const replyItemsList = [
  { id: 1, name: '一单一SKU', enName: 'one products under one order' },
  { id: 2, name: '一单二SKU', enName: 'two products under one order' },
  { id: 3, name: '一单三SKU', enName: 'three products under one order' },
];

// 所属平台状态转文字
function getReplyItemsListList(val,locale) {
  const item = this.replyItemsList.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.name : "";
}


/** 任务结算类型 */
export const settlementType = [
  { value: 0, label: '任务', enName: 'task' },
  { value: 1, label: '投诉', enName: 'complaint' },
];

// 任务结算类型转文字
function getSettlementTypeList(val,locale) {
  const item = this.settlementType.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.label : "";
}

/** 任务结算状态 */
export const settlementStatus = [
  { value: 0, label: '待结算', enName: 'unsettled' },
  { value: 1, label: '已结算', enName: 'settled' },
];

// 任务结算状态转文字
function getSettlementStatusList(val,locale) {
  const item = this.settlementStatus.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.name : "";
}
//明细类型
export const accountLogType = [
  { value: 1, label: '充值' ,disabled:true},
  { value: 2, label: '任务预扣' ,disabled:true},
  { value: 3, label: '预扣回退',disabled:true },
  { value: 4, label: '任务完成',disabled:true },
  { value: 5, label: '差额' },
  { value: 6, label: '线下抵扣' },
  { value: 7, label: '单量记录',disabled:true }
];
// 明细类型转文字
function getAccountLogTypeList(val) {
  const item = this.accountLogType.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? item.label : "";
}
//支付状态
export const payStatus = [
  { value: -1, label: '审核不通过' },
  { value: 0, label: '待审核' },
  { value: 1, label: '审核通过' },
];

// 支付状态转文字
function getPayStatusList(val) {
  const item = this.payStatus.filter(
    (item) => Number(item["value"]) === Number(val)
  )[0];
  return item ? item.label : "";
}
// 支付类型
export const payTypeList = [
  { id: 1, icon: 'icon-zhifubao', name: '支付宝', url: 'alipay.jpg' },
  {
    id: 3,
    icon: 'icon-zhaoshangyinhang1',
    name: '兴业银行',
    data: {
      bank: '兴业银行',
      subBank: '南京雨花支行',
      account: '622908403350937611',
      name: '柯金波',
    },
  },
  {
    id: 5,
    icon: 'icon-zhaoshangyinhang1',
    name: '公对公',
    data: {
      bank: '南京银行',
      subBank: '南京银行和会街支行',
      account: '0166230000000718',
      name: '航向标信息科技（南京）有限公司',
    },
  },
  { id: 2, icon: 'icon-weixinzhifu', name: '微信', url: 'wxpay.jpg' },
  { id: 4, name: '回款抵扣' },
];

// 支付类型转文字
function getPayTypeListList(val) {
  const item = this.payTypeList.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return item ? item.name : "";
}



/** 商家投诉类型 */
export const companyComplaintType = [
  {
    id: 1,
    name: '实际下单sku与任务sku不符',
    enName: 'The actual order SKU is inconsistent with the task SKU',
  },

  {
    id: 2,
    name: '实际下单数量sku与任务sku不符',
    enName: 'The actual order quantity SKU is inconsistent with the task SKU',
  },

  {
    id: 3,
    name: '实际下单快递sku与任务sku不符',
    enName: 'The actual order express SKU is inconsistent with the task SKU',
  },

  {
    id: 4,
    name: '未使用优惠劵或使用优惠劵与任务要求优惠劵不符',
    enName:
      'The coupon is not used or the coupon used is inconsistent with the coupon required by the task',
  },

  {
    id: 5,
    name: '实际评价与任务要求评价不符',
    enName: 'The actual evaluation is inconsistent with the task requirements',
  },

  {
    id: 6,
    name: '访客量未达到预期',
    enName: 'The number of visitors did not meet expectations',
  },

  {
    id: 7,
    name: '订单疑因违规操作导致订单或店铺异常',
    enName: 'It is suspected that the order or store is abnormal due to illegal operation',
  },

  { id: 8, name: '妥投失败', enName: 'Proper delivery failure' },

  { id: 9, name: '其他', enName: 'other' },
];

// 商家投诉类型转文字
function getCompanyComplaintTypeList(val,locale) {
  const item = this.companyComplaintType.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.name : "";
}

// 下单失败的原因类型
export const placeOrderfailType = [
  { id: 1, name: '优惠券不能使用（不在折扣范围、过期等）', enName: '' },
  { id: 2, name: '商品金额过大', enName: '' },
  { id: 3, name: '下单金额与任务下单金额不符', enName: '' },
  { id: 4, name: '下单sku与任务sku不符', enName: '' },
  { id: 5, name: '因重量，体积等问题导致物流无法派件', enName: '' },
  { id: 6, name: '任务商品主图与店铺商品主图不符', enName: '' },
  { id: 7, name: '其他', enName: '' },
]

/** 刷手投诉类型 */
export const serviceComplaintType = [
  { id: 1, name: '根据关键词无法找到商品', enName: 'Cannot find product by keyword' },

  { id: 2, name: '主图不一致', enName: 'Main image is inconsistent' },

  { id: 3, name: '优惠劵无法使用或不符', enName: 'Coupons are not valid or do not match' },

  {
    id: 4,
    name: '无法按照任务下单数量',
    enName: 'Unable to place order quantity according to task',
  },

  { id: 5, name: ' 其他', enName: 'other' },

  { id: 6, name: '买家号被封', enName: 'Buyer number is blocked' },
];
// 商家投诉类型转文字
function getserviceComplaintTypeList(val,locale) {
  const item = this.serviceComplaintType.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return  item ? locale==='en'?item.enName:item.name : "";
}
/** 刷手签收失败类型 */
export const serviceFailedType = [
  { id: 1, name: '未签收（商家要求拒收）', enName: 'Unsigned(Merchant requests rejection)' },

  { id: 2, name: '未签收（买家要求取消订单，买家未发货）', enName: 'Unsigned(The buyer requested to cancel the order, but the buyer did not ship it)' },

  { id: 3, name: '未签收（系统取消）', enName: 'Unsigned(System Cancellation)' },

  {
    id: 4,
    name: '未签收（快递员拒收）',
    enName: 'Unsigned(Rejected by courier)',
  },

  { id: 5, name: ' 未签收（账号被封）', enName: 'Unsigned(Account blocked)' },

  { id: 6, name: '未签收（收件人地址或电话问题）', enName: 'Unsigned(Recipient address or phone issue)' },
  { id: 7, name: ' 其他', enName: 'other' },
];

// 商家投诉类型转文字
function getFailedtTypeList(val,locale) {
  const item = this.serviceFailedType.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return  item ? locale==='en'?item.enName:item.name : "";
}
/** 刷手签收成功类型 */
export const serviceSuccesType = [
  { id: 0, name: '已签收（因账号被封无法上评）', enName: 'Signed for(Unable to comment due to account closure)' },
  { id: 1, name: ' 其他', enName: 'other' },
];

// 刷手签收成功类型转文字
function getSuccessTypeList(val,locale) {
  const item = this.serviceSuccesType.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return  item ? locale==='en'?item.enName:item.name : "";
}

/** 任务状态 */
export const taskStatus = [
  { id: 0, name: '待提交', enName: 'pending submission',loading:false },
  { id: 1, name: '待接单', enName: 'pending order',loading:false },
  { id: 2, name: '已接单', enName: 'Order received' ,loading:false },
  { id: 3, name: '已下单', enName: 'Ordered' ,loading:false },
  { id: 7, name: '待签收', enName: 'Shipped' ,loading:false },
  { id: 8, name: '签收成功', enName: 'Received successfully' ,loading:false },
  { id: -3, name: '签收失败', enName: 'Failed sign' ,loading:false },
  { id: 6, name: '待确认', enName: 'To be confirmed',loading:false  },
  { id: -2, name: '下单失败', enName: 'Order failed' ,loading:false },
  { id: 4, name: '已评论', enName: 'commented' ,loading:false },
  { id: 5, name: '已完成', enName: 'completed' ,loading:false },
  { id: -1, name: '已取消', enName: 'canceled' ,loading:false },
];

// 任务状态转文字
function gettaskStatusList(val,locale) {
  const item = this.taskStatus.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.name : "";
}
//处理类型
export const handleTaskStatus = [
  { id: 0, name: '结束任务',enName:'End Task'},
  { id: 1, name: '继续任务',enName:'Continue Task' }
];

// 任务状态转文字
function getHandleTaskStatusList(val,locale) {
  const item = this.handleTaskStatus.filter(
    (item) => Number(item["id"]) === Number(val)
  )[0];
  return item ? locale==='en'?item.enName:item.name : "";
}
// 收费付费标准 附加服务 刷手 和商家
export const otherFee =[
  {value: '0',valuesj: '0',name:'店铺follow关注',id:'collection',enName: 'Become Follower' },
  {value: '0',valuesj: '0',name:'产品心愿单',id:'xinyuan', enName: 'Add to Wishlist' },
  {value: '0',valuesj: '0',name:'	要求加入购物车',id:'cart', enName: 'Add to Cart'},
  {value: '0',valuesj: '0',name:'chat在线聊天',id:'chat', enName: 'Chat Seller before placing order'},
  {value: '0.5',valuesj: '0.5',name:'分享宝贝',id:'share', enName: 'Share goods' },
  {value: '0',valuesj: '0',name:'货比一家',id:'oneSku'},
  {value: '0',valuesj: '0',name:'货比两家',id:'twoSku'},
  {value: '0',valuesj: '0',name:'货比三家',id:'threeSku'},
  {value: '0',valuesj: '0',name:'浏览商品数量',id:'eye', enName: 'No. of views required'},
  {value: '4',valuesj: '4',name:'是否发空包',id:'coupon', enName: 'Whether to send empty packets',},
]

/** 附加服务列表 */
export const otherServiceList = [
  { name: 'other1', label: '店铺follow关注', value: 0, enName: 'Become Follower' },
  { name: 'other2', label: '产品心愿单', value: 0, enName: 'Add to Wishlist' },
  { name: 'other3', label: '要求加入购物车', value: 0, enName: 'Add to Cart' },
  { name: 'other4', label: 'chat在线聊天', value: 0, enName: 'Chat Seller before placing order' },
  { name: 'other5', label: '分享宝贝', value: 0.5, enName: 'Share goods' },
  { name: 'other6', label: '货比三家', value: 0, enName: 'Shop around', options: [
      { label: '不要求', value: 0 },
      { label: '货比一家', value: 1 },
      { label: '货比两家', value: 2 },
      { label: '货比三家', value: 3 },
    ],
  },
  { name: 'other7', label: '浏览商品数量', value: 0, enName: 'No. of views required' },
  { name: 'other8', label: '是否发空包', value: 4, enName: 'Whether to send empty packets',},
];

// 日期范围快捷键
const pickerOptions = {
  shortcuts: [{
    text: '最近一周',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }]
}
function getScrollTop(that) {
  let overflowY = that.$el.getElementsByClassName("el-table__body-wrapper")[0];
  if (!overflowY) {
    return;
  }
  overflowY.scrollTop = 0;
}
//店铺状态
const storeStatus = [
  {
    value: "1",
    label: "已开启",
  },
  {
    value: "0",
    label: "已关闭",
  },
]
const bannerArr=[
          'https://hangxiangbiao-guanwang.oss-ap-southeast-1.aliyuncs.com/yunpai/1.jpg',
      ]

export default {
  clientHeight,
  faceUrl,
  getRatio,
  getRatioFalse,
  getMenuUrl,
  loginEffectiveTime,
  pageArr,
  pageSize,
  pageSizeDp,
  accountStatus,
  getaccountStatusList,
  pickerOptions,
  getScrollTop,
  attestationStatus,
  getAttestationStateList,
  allPlatform,
  getAllPlatformList,
  settlementType,
  getSettlementTypeList,
  settlementStatus,
  getSettlementStatusList,
  accountLogType,
  getAccountLogTypeList,
  getPayStatusList,
  payStatus,
  payTypeList,
  getPayTypeListList,
  otherFee,
  getserviceComplaintTypeList,
  serviceComplaintType,
  companyComplaintType,
  getCompanyComplaintTypeList,
  gettaskStatusList,
  taskStatus,
  getHandleTaskStatusList,
  handleTaskStatus,
  getReplyItemsListList,
  replyItemsList,
  otherServiceList,
  allIsPost,
  allReplyItems,
  getallPlatformList,
  placeOrderfailType,
  storeStatus,
  bannerArr,
  serviceFailedType,
  getFailedtTypeList,
  getSuccessTypeList,
  serviceSuccesType


};
</script>



// WEBPACK FOOTER //
// src/utils/global.vue